exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".onboarding-container[data-v-65563b56] {\n  width: 100%;\n  min-height: 100vh;\n  overflow-x: hidden;\n}\n", ""]);

// exports
